import type { Checklist } from "~/features/integration/sharepoint/checklist-schema";
import { createSharePointChecklistClient } from "~/features/integration/sharepoint/sharepoint-checklist-client.server";
import { fetchJson } from "~/utils/fetch-json";

import { useQuery } from "@tanstack/react-query";
import { toMilliseconds } from "duration-fns";
import type { Jsonify } from "type-fest";

export type ChecklistsData = Jsonify<Awaited<ReturnType<typeof loader>>>;

export const CHECKLIST_QUERY_KEY = ["checklists-links"];

export async function loader() {
  const sharePointClient = createSharePointChecklistClient();
  const listItems = await sharePointClient.getChecklists();

  const lettersRemoved = removeLettersFromVehicleTypes(listItems);
  return lettersRemoved;
}

export const checklistsQueryFn = () =>
  fetchJson<ChecklistsData>("/api/resources/train-info/checklist", {
    timeoutMs: toMilliseconds({ seconds: 60 }),
  });

export const useChecklists = () => {
  return useQuery({
    queryKey: CHECKLIST_QUERY_KEY,
    queryFn: checklistsQueryFn,
  });
};

// The locomotives from Bergen technically have the type `el18`, but whenever we reference a train by its type,
// the `el` is excluded, i.e. `18-2257`. For this reason, filter away all letters from the list of checklists.
// TODO: Ensure this works with wagons when we add support for this in the future.
const removeLettersFromVehicleTypes = (list: Checklist[]): Checklist[] =>
  list.map(({ vehicleTypes, ...rest }) => ({
    ...rest,
    vehicleTypes: vehicleTypes.map((value) => value.replaceAll(/\D/g, "")),
  }));
